//
// functions
//
import * as C from '@/app/special/consts'

export function optionPrice (opt, days, quantity) {
  if (!opt) {
    return 0
  }

  let scale

  // 日数
  if (opt.chargeType === C.PRICETYPE_TIME) {
    scale = 1
  } else if (days <= opt.limitDays) {
    scale = days
  } else {
    scale = opt.limitDays
  }

  // 数量
  scale *= quantity

  // 料金を算出する
  return scale * opt.price
}

export function deliPrice (deli, value) {
  if (!deli || !deli.enabled || value === C.WAY_NONE) {
    return 0
  }

  if (value === C.WAY_ROUND) {
    return deli.round
  }

  return deli.oneway
}

export function insurancePrice (ins, days) {
  if (!ins || ins.id === 0) {
    return 0
  }

  if (days < ins.limitDays) {
    return ins.price * days
  }

  return ins.price * ins.limitDays
}
